import React from 'react';
import { useSearchParams } from 'react-router-dom';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Container, i18n } from '../../../../symphony';

import { HotToday } from '../HotToday/HotToday';
import { CodeBitsSearch } from '../CodeBitsSearch/CodeBitsSearch';
import { CodeBitsFilter } from '../CodeBitsFilter/CodeBitsFilter';
import { SlCodeBitsContext } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { CodeBitsList } from '../CodeBitsList/CodeBitsList';
import { CodeBitsPaginationContainer } from '../CodeBitsPaginationContainer/CodeBitsPaginationContainer';
import { useComponentWillMount } from '../../../../shared/public/SlUtils/useComponentWillMount';
import { SlHelmet } from '../../../../shared/public/SlHelmet/SlHelmet';

import s from './CodeBitsListPage.scss';

export function CodeBitsListPage() {
	useStyles(s);
	const [searchParams] = useSearchParams();
	const { actions$ } = Container.take(SlCodeBitsContext, SlActions);

	useComponentWillMount(() => {
		actions$.next({
			type: ActionType.OnCodeBitsListPageMountHandler,
			requestType: RequestType.Parallel,
		});
	});

	return (
		<>
			<SlHelmet
				title={i18n.t('web-code.meta-title')}
				description={i18n.t('web-code.meta-description')}
			/>
			<div className="sl-code-bits-list-page">
				<div className="sl-code-bits-list-page__main-section">
					<h1 className="sl-code-bits-list-page__main-section__title">
						{i18n.t('web-code.list-title')}
					</h1>
					<CodeBitsSearch />
					<CodeBitsFilter />
					<CodeBitsList
						key={[
							searchParams.get('page'),
							searchParams.get('ordering'),
							searchParams.get('query'),
							searchParams.get('language'),
						].join('-')}
					/>
					<CodeBitsPaginationContainer />
				</div>
				<HotToday />
			</div>
		</>
	);
}
